import { apiClient } from "./ApiConfig";

export const WishlistApi = {
  addItem: (productId: number) => {
    return apiClient.post("/wishlist/add", { product_id: productId });
  },
  removeItem: (productId: number) => {
    return apiClient.post("/wishlist/remove", { product_id: productId });
  },
  getItems: () => {
    return apiClient.get("/wishlist/items");
  },
  isInWishlist: (productId: number) => {
    return apiClient.get(`/wishlist/items/${productId}`);
  },
};
